import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { MAVLINK_MESSAGE_IDS as MAVLINK_MSG } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';
import EventEmitter from '@/libs/EventEmitter';

const useWaitingRobotTimer = (robotId, timeout = 5000) => {
  const heartbeat = useRobotTelemetry(robotId, MAVLINK_MSG.HEARTBEAT);
  const robotStatus = useSelector((state) => state.robotStatus[robotId]);

  useEffect(() => {
    const waitingTimer = setTimeout(() => {
      EventEmitter.publish(`${robotId}/event/waitingRobot`);
    }, timeout);

    // 10분 후 연결 해제
    const disconnectTimer = setTimeout(() => {
      EventEmitter.publish(`${robotId}/event/disconnectRobot`);
    }, 600 * 1000);

    return () => {
      EventEmitter.publish(`${robotId}/event/reconnectRobot`);
      clearTimeout(waitingTimer);
      clearTimeout(disconnectTimer);
    };
  }, [heartbeat, robotStatus]);
};

export default useWaitingRobotTimer;
